import { Alert } from 'react-bootstrap';
import type { TppFlashVariant } from './useTppFlashMessage';

type Props = {
  message: string | null;
  variant?: TppFlashVariant;
  onClose: () => void;
};

/** 操作成功／失敗の短いフィードバック（一覧上部に固定して見逃しにくくする） */
export default function TppFlashAlert({ message, variant = 'success', onClose }: Props) {
  if (!message) return null;
  return (
    <Alert
      id="tpp-flash"
      variant={variant}
      dismissible
      onClose={onClose}
      className="py-2 sticky-top shadow-sm"
      style={{ zIndex: 1080, top: '0.5rem' }}
      role={variant === 'danger' ? 'alert' : 'status'}
      aria-live={variant === 'danger' ? 'assertive' : 'polite'}
    >
      {message}
    </Alert>
  );
}
